import PrivateRoute from './PrivateRoute'
import PublicRoute from './PublicRoute'
import Header from '../components/Header'
import Footer from '../components/Footer'
import Home from '../components/Home'
import Help from '../components/Help'
import Content from '../components/Content'
import React from 'react'
import { connect } from 'react-redux'
import { Switch } from 'react-router-dom'
import UserInfo from '../components/UserInfo'
import UserPreferences from '../components/UserPreferences'
import ContentSet from '../components/ContentSet'
import FullStory, { FullStoryAPI } from 'react-fullstory'
import RedirectPage from '../components/RedirectPage'
import GenericErrorPage from '../components/GenericErrorPage'
import Search from '../components/Search'
import SaveSearch from '../components/SaveSearch'
import ScrollToTop from '../components/ScrollToTop'
import Conference from '../components/Conference'
import Impersonate from '../components/Impersonate'

var ES6Promise = require('es6-promise')
ES6Promise.polyfill()

const Routes = (props) => {
  const isConnected = !!props.user
  const userRole = isConnected ? (props.user.profile.Role != null ? props.user.profile.Role : '') : ''
  const userEmail = isConnected ? (props.user.profile.name != null ? props.user.profile.name : '') : ''
  const userName = isConnected ? (props.user.profile.UserName != null ? props.user.profile.UserName : '') : ''

  const ORG_ID = process.env.FULLSTORY_ORGID
  FullStoryAPI('setUserVars', {
    environment: 'MLex2.0'
  })

  if (props.user) {
    const encUserId = props.user.profile.encUserID
    const encAccId = props.user.profile.encCompanyID
    pendo.initialize({
      visitor: {
        id: encUserId
      },

      account: {
        id: encAccId
      }
    })
  }

  return (

    <>
      <div className='app'>
        <FullStory org={ORG_ID} />
        <ScrollToTop />
        <Header isConnected={isConnected} userRole={userRole} userName={userName} path={props.location.pathname} />
        <section role='main' className='content-container'>
          <div className={(props.location.pathname === '/search') ? 'grid-wrapper search' : 'grid-wrapper'}>
            <Switch>
              <PrivateRoute exact path='/' component={RedirectPage} />
              <PrivateRoute path='/home' component={Home} />
              <PublicRoute path='/help' component={Help} />
              <PrivateRoute path='/content/:id' component={Content} />
              <PrivateRoute path='/user' component={UserInfo} />
              <PrivateRoute path='/personalize' component={UserPreferences} />
              <PrivateRoute path='/conference' component={Conference} />
              <PrivateRoute exact path='/contentSet' component={ContentSet} />
              <PrivateRoute path='/contentSet/:id' component={ContentSet} />
              <PrivateRoute path='/search' component={Search} />
              <PrivateRoute exact path='/saveSearch' component={SaveSearch} />
              <PrivateRoute path='/saveSearch/:id' component={SaveSearch} />
              <PrivateRoute path='/impersonate/:id' component={Impersonate} />
              <PrivateRoute path='/error' component={GenericErrorPage} />
            </Switch>
          </div>
        </section>
        <Footer userEmail={userEmail} />
      </div>
    </>
  )
}

function mapStateToProps (AppState) {
  return {
    user: AppState.oidc.user,
    location: AppState.router.location
  }
}

function mapDispatchToProps (Dispatch) {
  return {
    Dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Routes)
